
import { calculateNEV } from './scoring';

/**
 * Calculates a detailed breakdown of all BEAM score components
 * 
 * This function processes survey responses to generate a comprehensive
 * score breakdown with emotional metrics, business metrics, and AI insights
 * 
 * @param responses - Survey responses to analyze
 * @param industry - Optional industry for benchmarking
 * @returns ScoreBreakdown - Complete analysis of all BEAM metrics
 */
export const calculateScoreBreakdown = (responses: any, industry?: string) => {
  console.log("Calculating score breakdown...");
  
  // Make sure we call the main scoring function and return its result
  const results = calculateNEV(responses, industry);
  
  // Debug logs to verify EROI calculation
  console.log("Score breakdown calculated:", {
    totalNEV: results.totalNEV,
    overallScore: results.overallScore,
    eroi: results.eroi,
    certification: results.certification,
    recommendations: results.recommendations?.length || 0
  });
  
  // Only cap EROI at 5.0 if it exceeds that value
  // This allows for a more realistic distribution of EROI values
  if (results.eroi !== undefined && results.eroi > 5.0) {
    results.eroi = 5.0;
    console.log("EROI capped at maximum value of 5.0");
  }
  
  // Determine certification level based on overall score (on 0-100 scale)
  // Note: overallScore is on 0-10 scale, so we multiply by 10 for 0-100 scale
  const scaledScore = results.overallScore * 10; // Convert to 0-100 scale
  
  if (scaledScore >= 90) {
    results.certification = 'Gold';
  } else if (scaledScore >= 80) {
    results.certification = 'Silver';
  } else if (scaledScore >= 70) {
    results.certification = 'Bronze';
  } else {
    results.certification = null;
  }
  
  console.log(`Certification level assigned: ${results.certification || 'None'}`);
  
  return results;
};
